// import Instafeed from "../../../node_modules/instafeed.js/instafeed";
import "slick-carousel";
import "slick-carousel/slick/slick.css";

export default class InstagramFeed {
  constructor(el) {
    this.el = el;
    this.slider = this.el.find(".js-instaSlider");
    this.next = this.el.find(".js-instaSliderNext");
    this.prev = this.el.find(".js-instaSliderPrev");

    this.events();
  }

  events() {
    this.initFeedAndSlider();
  }

  initFeedAndSlider() {
    // const feed = new Instafeed({
    //     get: 'user',
    //     userId: '1526134923',
    //     clientId: '8dcf4cfbc96847898199f149fe332a27',
    //     accessToken: '1526134923.1677ed0.19329091e10246ba9645d44a0cbd8640',
    //     sortBy: 'most-recent',
    //     template: '<li class="social-images__list__item"><a href="{{link}}" target="_blank" class="social-images__list__anchor"><div class="social-images__list__image"><img src="{{image}}" alt="..." /></div></a></li>',
    //     limit: 10,
    //     resolution: 'standard_resolution',
    //     after: (data) => {
    //       this.slider.slick({
    //             slidesToShow: 4,
    //             infinite: true,
    //             variableWidth: true,
    //             centerMode: true,
    //             centerPadding: '60px 0px 0px',
    //             initialSlide: 2,
    //             arrows: false,
    //             // prevArrow: '<div class="slick-arrow slick-prev"><span class="icon-small-arrow-left"></span></div>',
    //             // nextArrow: '<div class="slick-arrow slick-next"><span class="icon-small-arrow-right"></span></div>',
    //             responsive: [
    //               {
    //                 breakpoint: 1100,
    //                 settings: {
    //                   slidesToShow: 3
    //                 }
    //               },
    //               {
    //                 breakpoint: 767,
    //                 settings: {
    //                   slidesToShow: 2
    //                 }
    //               }, {
    //                 breakpoint: 540,
    //                 settings: {
    //                   slidesToShow: 1,
    //                   initialSlide: 0,
    //                   arrows: false
    //                 }
    //               }
    //             ]
    //         });
    //     }
    // });

    let placeholder = $(".placeholder");
    let fallbackImg = placeholder.attr("data-placeholder");
    // alert(fallbackImg);
    $.ajax({
      url: "https://www.juicer.io/api/feeds/dubaidesignweek?per=10",
      contentType: "application/json",
      dataType: "json",
      success: function (result) {
        let string_div = "";
        let postlist = result.posts.items;
        let instaImg = '';
        for (var i = 0, len = postlist.length; i < len; ++i) {
          console.log(postlist[i]);
          if(postlist[i].additional_photos.length > 0){
            console.log(postlist[i].additional_photos.length);
             instaImg = postlist[i].additional_photos[1];
          }else{
             instaImg = postlist[i].image;
          }

          let instaBlock = `<li class="social-images__list__item"><a href="${postlist[i].full_url}" target="_blank" class="social-images__list__anchor">
            <div class="social-images__list__image"><img src="${instaImg}" onerror="this.onerror=null;this.src='${fallbackImg}';" alt="..." /></div></a></li>`;
          string_div = string_div + instaBlock;
        }

        $("#instafeed").append(string_div);

        $(".js-instaSlider").slick({
          slidesToShow: 4,
          infinite: true,
          variableWidth: true,
          centerMode: true,
          centerPadding: "60px 0px 0px",
          initialSlide: 2,
          arrows: false,
          // prevArrow: '<div class="slick-arrow slick-prev"><span class="icon-small-arrow-left"></span></div>',
          // nextArrow: '<div class="slick-arrow slick-next"><span class="icon-small-arrow-right"></span></div>',
          responsive: [
            {
              breakpoint: 1100,
              settings: {
                slidesToShow: 3,
              },
            },
            {
              breakpoint: 767,
              settings: {
                slidesToShow: 2,
              },
            },
            {
              breakpoint: 540,
              settings: {
                slidesToShow: 1,
                initialSlide: 0,
                arrows: false,
              },
            },
          ],
        });
      },
    });

    this.next.on("click", (event) => this.slider.slick("slickNext"));
    this.prev.on("click", (event) => this.slider.slick("slickPrev"));
  }
}
